<script lang="ts">
  import LayoutGrid, { Cell } from '@smui/layout-grid';
  import { marked } from 'marked';
  import { getAppConfig } from '../../../../common/config/app-config';
  import HorizontalDivider from '../../../common/components/HorizontalDivider.svelte';
  import PictureTag from '../../../common/lazy-components/PictureTag.svelte';
  import { getBlogImageAltTextFromUrl } from '../../services/blog-data-services';

  export let data;
  const { lang } = getAppConfig();
</script>

<section class="blog-centre-variant-section">
  <LayoutGrid>
    <Cell class="blog-detail-center-text-container" spanDevices={{ desktop: 12, tablet: 8, phone: 4 }}>
      <div class="blog-detail-center-text">
        {#if data?.title}
          <div class="blog-detail-center-title-container">
            <h5 class="blog-detail-center-title">
              {data?.title}
            </h5>
          </div>
        {/if}
      </div>
    </Cell>
    <Cell class="blog-center-description-container" spanDevices={{ desktop: 12, tablet: 8, phone: 4 }}>
      <div class="blog-detail-center-description-container">
        {#if data?.descriptionAr || data?.descriptionEn}
          <p class="blog-detail-center-description">
            {@html lang === 'en' ? marked(`${data?.descriptionEn}`) : marked(`${data?.descriptionAr}`)}
          </p>
        {/if}
      </div>
    </Cell>
    <Cell class="blog-center-image-container" spanDevices={{ desktop: 12, tablet: 8, phone: 4 }}>
      <div class="blog-detail-center-image">
        <PictureTag image={data?.image} alt={getBlogImageAltTextFromUrl(data?.image)} width="100%" />
      </div>
    </Cell>
  </LayoutGrid>
</section>
{#if data?.divider}
  <HorizontalDivider height="2" />
{/if}

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';
  .blog-centre-variant-section {
    :global {
      .mdc-layout-grid {
        padding: 0;
      }
    }
    .blog-detail-center-text {
      .blog-detail-center-title {
        font-size: 30px;
        font-weight: 700;
        line-height: 40px;
        color: $neutral-dark-01;
        margin: 0;
      }
    }
    .blog-detail-center-description {
      margin: 0;
      :global {
        p {
          font-size: 20px;
          font-weight: 400;
          line-height: 26px;
          color: $neutral-dark-01;
          margin: 0;
          a {
            text-decoration: underline;
          }
        }
      }
    }
    :global(img) {
      border-radius: 20px;
    }
  }
</style>
